import { Close } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';

import { Button } from '@/components';
import { Assessment, Episode } from '@/types';

interface AssessmentHeaderProps {
  episode: Episode;
  assessment: Assessment;
  quitAssessment: () => void;
  isPreview: boolean;
}

export const AssessmentHeader = ({
  episode,
  assessment,
  quitAssessment,
  isPreview,
}: AssessmentHeaderProps) => {
  const cta = isPreview ? 'Exit Preview' : 'Quit Assessment';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: { xs: 1, md: 4 },
      }}>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box
          component="img"
          id="episode-card-img"
          src={episode.cover}
          alt="cover"
          sx={[
            {
              width: '100%',
              maxWidth: 120,
              height: 'auto',
              objectFit: 'cover',
              objectPosition: 'center',
              borderRadius: 2,
              overflow: 'hidden',
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              justifySelf: 'center',
            },
            isPreview
              ? {
                  filter: 'grayscale(1)',
                }
              : {},
          ]}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
            pr: { xs: 4, sm: 2 },
          }}>
          <Typography variant="h2">Qualified Assessment</Typography>
          <Typography variant="h4">{episode.name}</Typography>
          <Typography variant="body3SemiBold" sx={{ color: 'secondary.main' }}>
            {assessment.questions.length || 0} Questions Total
          </Typography>
        </Box>
      </Box>
      <Box>
        <Button
          variant="secondary"
          label={cta}
          onClick={quitAssessment}
          sx={{ display: { xs: 'none', md: 'inline-flex' } }}
          tabIndex={1}
        />
        <IconButton
          sx={{
            display: { xs: 'inline-flex', md: 'none' },
            position: 'absolute',
            right: 8,
            top: 8,
          }}
          onClick={quitAssessment}
          name="quit-assessment"
          aria-label={cta}
          tabIndex={1}>
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
};
